import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";
import Topline from "@/components/static/Topline";
import { HeadlineProps } from "@/lib/types";

const headlineVariants = cva("leading-tight text-primary", {
    variants: {
        tag: {
            h1: "text-h1",
            h2: "text-h2",
            h3: "text-h3",
            h4: "text-h4",
            h5: "text-h5",
            h6: "text-h6",
            span: "",
        },
    },
    defaultVariants: {
        tag: "span",
    },
});

export default function Headline(props: HeadlineProps) {
    const HeadlineTag = `${props.tag ? props.tag : "h2"}` as keyof JSX.IntrinsicElements;
    const itemsAlign = `items-${props.align ?? "start"}`;
    const textAlign = `text-${props.align == "center" ? "center" : ""}`;
    return (
        <hgroup
            className={cn(
                "group w-full flex flex-col gap-2 xl:gap-4 mb-6",
                itemsAlign,
                textAlign,
                props.wrapperClassName
            )}
        >
            {props.topline && (
                <Topline className={props.toplineClassName} align={props.align}>
                    {props.topline}
                </Topline>
            )}
            {props.children && (
                <HeadlineTag className={cn(headlineVariants({ tag: props.tag }), props.className)}>
                    {props.children}
                </HeadlineTag>
            )}
        </hgroup>
    );
}
